module.exports = __webpack_public_path__ + "static/img/ar.317b40ef.png";